<div class="next-task-info">
  <div class="flex flex-wrap w-100">
    <div class="flex-grow-1" style="font-weight: 600">
      <span *ngIf="showTime" class="duration-value">
        {{ hmsto2dp(showTime) }}
        &nbsp;
      </span>
      <span class="mileage-value" *ngIf="showMiles">
        {{ showMiles | number : '1.0-0' }} {{ milesLabel }}
      </span>
      <span *ngIf="hasTaskSwitch" class="task-changes-value">
        <span *ngIf="taskSwitchCount == 1">1 Task Change. </span>
        <span *ngIf="taskSwitchCount > 1"> {{ taskSwitchCount }} Task Changes.</span>
      </span>
      <span *ngIf="hasCarryOver" class="carry-over-value">
        <span *ngIf="carryOverCount > 1">{{ carryOverCount }} Carryovers</span>
        <span *ngIf="carryOverCount == 1 || carryOverCount == null"> Carryover</span>
      </span>
    </div>
  </div>
</div>
